




































import Vue from 'vue'
import { Observer } from 'mobx-vue'
import {Component, Prop} from 'vue-property-decorator'

import { VersionInfo, ServerInfo } from '../../../stores/System'
import { Release } from '../../../stores/Releases'

import {url} from '../../../rundeckService'

import RundeckLogo from '../../svg/RundeckLogo.vue'

import Copyright from '../../version/Copyright.vue'
import RundeckVersion from '../../version/RundeckVersionDisplay.vue'
import VersionDisplay from '../../version/VersionIconNameDisplay.vue'
import ServerDisplay from '../../version/ServerDisplay.vue'

@Observer
@Component({components: {
    ServerDisplay,
    VersionDisplay,
    RundeckVersion,
    RundeckLogo,
    Copyright
}})
export default class RundeckInfoWidget extends Vue {
    @Prop()
    version!: VersionInfo

    @Prop()
    latest!: Release

    @Prop()
    server!: ServerInfo

    async mounted() {
    }

    welcomeUrl() {
        return url('menu/welcome').toString()
    }
}
